import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ConfirmService } from '../../../core/components/confirm/confirm.service';
import { User } from '../../../core/modelos/user';
import { LoginService } from '../login/login.service';
import { UsuariosService } from './usuarios.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
    selector: 'fuse-usuarios-datatable',
    templateUrl: './usuarios.component.html',
    styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements AfterViewInit {
    displayedColumns = ['nombre', 'apellidos', 'email', 'cliente', 'acciones'];
    dataSource: MatTableDataSource<User>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // Usuario conectado
    userToken: User;

    usuarios: Array<User>;

    constructor(
        private usuariosService: UsuariosService,
        private confirmService: ConfirmService,
        private loginService: LoginService,
        private notificaciones: NotificacionesService,
        private translate: TranslateService
    ) {

        this.userToken = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
        if (this.userToken.rol.id === 3) {
            this.loginService.logout();
        } else {
            this.getUsuarios();
        }

    }

    getUsuarios() {

        this.usuariosService.getUsuarios().subscribe(
            data => {
                if (data.success) {
                    this.usuarios = data.items;
                    // Assign the data to the data source for the table to render
                    this.dataSource = new MatTableDataSource(this.usuarios);

                    // Esto estaba en el afterViewInit
                    this.dataSource.paginator = this.paginator;

                    // Indica de dónde sacar los datos para ordenar
                    this.dataSource.sortingDataAccessor = (item, property) => {
                        switch (property) {
                            case 'nombre': return item.nombre.toLocaleLowerCase();
                            case 'apellidos': return item.apellidos.toLocaleLowerCase();
                            case 'email': return item.email.toLocaleLowerCase();
                            case 'cliente': {
                                if (item.cliente) {
                                    return item.cliente.nombre.toLocaleLowerCase()
                                }
                            }
                                break;
                            default: return item[property];
                        }
                    };

                    this.dataSource.sort = this.sort;

                    // Traduzco etiqueta si es español
                    if (this.translate.currentLang === 'es') {
                        this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
                    }
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.SinUsuarios);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    /**
     * Set the paginator and sort after the view init since this component will
     * be able to query its view for the initialized paginator and sort.
     */
    ngAfterViewInit() {
    }

    applyFilter(filterValue: string) {
        this.dataSource.data = this.usuarios;

        if (filterValue && filterValue.trim() !== '') {
            this.dataSource.data = this.dataSource.data.filter(
                usuario => {
                    if (usuario.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return usuario.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (usuario.apellidos.toLowerCase().includes(filterValue.toLowerCase())) {
                        return usuario.apellidos.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (usuario.email.toLowerCase().includes(filterValue.toLowerCase())) {
                        return usuario.email.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (usuario.cliente) {
                        if (usuario.cliente.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                            return usuario.cliente.nombre.toLowerCase().includes(filterValue.toLowerCase());
                        }
                    }
                }
            );
        }
    }
    delete(id: number) {
        this.confirmService.confirm(
            this.notificaciones.mensajes.IdiomaActual.Usuarios.TituloBorrar,
            this.notificaciones.mensajes.IdiomaActual.Usuarios.MensajeBorrar).subscribe(
                result => {
                    if (result) {
                        this.usuariosService.deleteUsuario(id).subscribe(
                            data => {
                                if (data.success) {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioBorrado);
                                    this.getUsuarios();
                                } else {
                                    // CONTROLAR ERROR
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.UsuarioNOBorrado);
                                }
                            },
                            err => {
                                // CONTROLAR ERROR
                                this.notificaciones.errorServidor(err.status);
                            }
                        );
                    }

                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/usuarios/usuarios.component.ts